import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Label } from '../../../../../CommonComponents/OPL/Label/Label';
import { Radio } from '../../../../../CommonComponents/OPL/Radio/Radio';
import { InsuranceData } from '../../../useInsurance';

interface Props {
  data: InsuranceData;
}

export const LifeInsurancePolicyType = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="LifeInsurancePolicyType"
      render={({ field: { value, onChange } }) => {
        return (
          <Box role="radiogroup" aria-labelledby="life-insurance-policy-type--label">
            <Label id="life-insurance-policy-type--label" mb="4">
              Policy Type
            </Label>

            <Box display="flex">
              {data.Options.LifeInsurancePolicyTypeOptions.map(({ value: v, label }) => (
                <Radio
                  key={label}
                  name="LifeInsurancePolicyType"
                  checked={value === v}
                  onChange={() => onChange(v)}
                  mr="8"
                >
                  {label}
                </Radio>
              ))}
            </Box>
          </Box>
        );
      }}
    />
  );
};
